import React from 'react';
import * as Ui from './styles';

export default function LoadingMenu({ className }) {
  return (
    <Ui.Container className={className}>
      <Ui.Message>{'Carregamento em progresso. Aguarde...'}</Ui.Message>
    </Ui.Container>
  );
}
